import { useEffect, useState } from "react"
import { FeaturedProject } from "config"
import {
  ArtBlocksProjectMetadata,
  fetchFeaturedProjectTokens,
} from "utils/artBlocksMetadataApi"
import { FeatureFilters } from "utils/featureFilters"
import { OrderDirection } from "utils/types"

const useArtBlocksProjectTokens = (
  project: FeaturedProject,
  limit: number,
  offset: number,
  orderDirection: OrderDirection,
  featureFilters?: FeatureFilters
) => {
  const [data, setData] = useState<ArtBlocksProjectMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(false)

    fetchFeaturedProjectTokens(project, limit, offset, orderDirection, featureFilters)
      .then((projectMetadata) => {
        if (!cancelled) setData(projectMetadata || null)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [project, limit, offset, orderDirection, featureFilters])

  return { data, loading, error }
}

export default useArtBlocksProjectTokens
